import { Box, Center, VStack } from '@chakra-ui/react';
import { _js } from '@ifixit/localize';
import { SSOButton } from './SSOButton';
import { GoogleSSOButton } from './GoogleSSOButton';
import { FacebookSSOButton } from './FacebookSSOButton';
import { AppleSSOButton } from './AppleSSOButton';
import { TextError } from './FormError';

export function SSOLoginButtons({
   loginHandler,
   error,
   setError,
   register,
}: {
   loginHandler: (response: any) => void;
   error: string | null;
   setError: (error: string) => void;
   register?: boolean;
}) {
   if (
      !(
         App.ssoLoginUrl ||
         App.googleLoginEnabled ||
         App.facebookLoginEnabled ||
         App.appleLoginEnabled
      )
   ) {
      return null;
   }

   return (
      <>
         <VStack spacing={3} width="100%">
            {App.ssoLoginUrl && (
               <SSOButton
                  href={App.ssoLoginUrl}
                  text={register ? _js('Sign up with SSO') : _js('Sign in with SSO')}
               />
            )}
            {App.googleLoginEnabled && (
               <GoogleSSOButton
                  setError={setError}
                  loginHandler={loginHandler}
                  text={register ? _js('Sign up with Google') : _js('Sign in with Google')}
               />
            )}
            <AppleSSOButton
               setError={setError}
               loginHandler={loginHandler}
               text={register ? _js('Sign up with Apple') : _js('Sign in with Apple')}
            />
            <FacebookSSOButton
               setError={setError}
               loginHandler={loginHandler}
               text={register ? _js('Sign up with Facebook') : _js('Sign in with Facebook')}
            />
            <TextError>{error}</TextError>
         </VStack>
         <Box
            display="flex"
            placeContent="center"
            height={5}
            position="relative"
            width="100%"
            sx={{
               '&:before': {
                  content: '""',
                  height: '1px',
                  backgroundColor: 'gray.300',
                  borderBottomWidth: '1px',
                  borderColor: 'gray.300',
                  position: 'absolute',
                  top: '50%',
                  transform: 'translateY(50%)',
                  width: 'inherit',
                  zIndex: 0,
               },
            }}
         >
            <Center
               as="span"
               bgColor="white"
               display="inline-flex"
               fontSize="md"
               height="inherit"
               paddingX={6}
               position="relative"
               textTransform="uppercase"
            >
               {_js('or')}
            </Center>
         </Box>
      </>
   );
}
